<template>
  <v-footer class="indigo links__container">
    <span class="white--text credits__text hidden-sm-and-down">{{ credits }}</span>
  </v-footer>
</template>

<script>
export default {
  data () {
    return {
      credits: '© 2017-2018'
    }
  }
}
</script>

<style lang="scss">
  .credits {
    &__text {
      position: absolute;
      right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue